// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Categories__container___2DF4x{margin-bottom:80px;background-color:#122182}.Categories__inner___1iicI{padding:48px 30px}@media (max-width:719px){.Categories__inner___1iicI{padding:45px}}.Categories__title___5asfZ{color:#fff;font-weight:200;font-size:40px;line-height:45px;text-align:center}.Categories__categoryList___ymtvg{display:flex;flex-wrap:wrap;justify-content:center;margin-top:40px}.Categories__categoryList___ymtvg li{margin:4px}@media (min-width:720px){.Categories__categoryList___ymtvg li{margin:12px}}.Categories__category___7yjMP a{color:inherit;font-size:20px;line-height:32px;display:block;padding:8px 20px;border-radius:24px;color:#fff;font-weight:400;text-decoration:none;background-color:#1b31a4;transition-duration:.3s;transition-property:color,background-color}.Categories__category___7yjMP a:hover{font-weight:400;background-color:#2441c5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "Categories__container___2DF4x",
	"inner": "Categories__inner___1iicI",
	"title": "Categories__title___5asfZ",
	"categoryList": "Categories__categoryList___ymtvg",
	"category": "Categories__category___7yjMP"
};
module.exports = ___CSS_LOADER_EXPORT___;
